export const ASSISTANT_ANALYZE_ERROR = 'Ошибка при анализе запроса ассистента:';
export const ASSISTANT_CREATE_LEAD_ERROR = 'Ошибка при создании лида ассистента:';
export const ASSISTANT_UPDATE_LEAD_ERROR = 'Ошибка при обновлении лида ассистента:';
export const ASSISTANT_WIDGET_LINK_ERROR =
  'Ошибка при получении данных перехода из виджета:';
